export default class SelectizeController
{
	constructor($http) {
		this.$http = $http;

		this.configurations = {};
	}

	// 0 - no create
	// 1 - admin create
	// 2 - anyone create
	getConfiguration(endpoint, create, maxItems) {
		if (typeof this.configurations[endpoint] !== 'undefined') {
			return this.configurations[endpoint];
		}

		let config = {};
		config.valueField = 'id';
		config.labelField = 'name';
		config.searchField = 'name';
		config.maxItems = maxItems;
		config.preload = true;

		config.load = (query, callback) => {
			this.$http({
				method: 'GET',
				url: '/api/'+endpoint
			}).then((response) => {
				callback(response.data.data);
			}, (response) => {
				callback();
			});
		}

		if (create === 2 || (create === 1 && window.admin)) {
			config.create = (input, callback) => {
				this.$http({
					method: 'POST',
					url: '/api/'+endpoint,
					data: {
						name: input
					}
				}).then((response) => {
					callback(response.data.data);
				}, (response) => {
					callback();
				});
			};
		}

		return this.configurations[endpoint] = config;
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/records/selectize.controller.js
 **/